import React, {
  useEffect,
  useState,
  useCallback,
  Dispatch,
  SetStateAction,
} from "react";
import styled from "styled-components";
import LineBox from "../../../../../DefaultStyles/LineBox";
import {
  ChatContainer,
  ChatContent,
  ChatHeader,
  ChatHeaderItem,
  ChatMessage,
  ChatRow,
  ChatRowItem,
  LatestMessageBadge,
  chatServerUrl,
  chatSocketUrl,
} from "../../RecentChatAll";
import Flex from "../../../../../DefaultStyles/Flex";
import dayjs from "dayjs";
import useIsMobile from "../../../../../../hooks/useIsMobile";
import { findUrl } from "../../../../../../ApiWeb/ApiWebTS";
import { IMessageData } from "../RecentChat";
import {
  decryptChat,
  encryptChat,
} from "../../../../../../ApiTS/web/ApiChatTS";
import Loader from "../../../../../DefaultStyles/Loader";
import { toast } from "react-toastify";
import { useInView } from "react-intersection-observer";
import axios from "axios";
import { io } from "socket.io-client";
import moment from "moment";

interface LinkidChatTableProps {
  chatId?: string;
  roomId: number;
  setRoomId: Dispatch<SetStateAction<number>>;
  messageData: IMessageData[];
  setMessageData: Dispatch<SetStateAction<IMessageData[]>>;
}

let mountCount = 1;

export default function LinkidChatTable({
  chatId,
  roomId,
  setRoomId,
  messageData,
  setMessageData,
}: LinkidChatTableProps) {
  const isMobile = useIsMobile();

  const tableHead = ["MSG ID", "보낸 사람", "내용", "발송 일시", "읽음"];

  const [page, setPage] = useState(0);
  const [didMount, setDidMount] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [lastRef, lastInView] = useInView({
    threshold: 0.8,
    fallbackInView: true,
  });

  const encMsg = "나는채팅" + moment().format("DDHHYYYYMM") + "_0";
  const encOwnerSuperKey = encryptChat(encMsg);
  const encOwnerSuperKeyValueSid = "tbvjzl" + `${0}_` + encOwnerSuperKey;

  const getAllChat = useCallback(
    async (needReload?: boolean, changedChatId?: string) => {
      setIsLoading(true);

      const queryStr = `${chatServerUrl}/room/reload`;

      try {
        const response = await axios.post(queryStr, {
          sid: encOwnerSuperKeyValueSid,
          partyid: changedChatId
            ? +changedChatId?.split("@")[0]!
            : +chatId?.split("@")[0]!,
          ownerid: changedChatId
            ? +changedChatId?.split("@")[1]!
            : +chatId?.split("@")[1]!,
          memberid: changedChatId
            ? +changedChatId?.split("@")[2]!
            : +chatId?.split("@")[2]!,
          mindex: needReload ? 0 : messageData?.length ?? 0,
          size: isMobile ? 30 : 20,
        });

        if (response?.status === 201) {
          setIsLoading(false);
          setHasMore(response?.data?.totalPage > page ? true : false);
          setRoomId(response?.data?.roomId ?? 0);

          console.log("메세지들은???    ", response?.data?.items);

          if (needReload) {
            setMessageData([]);

            setTimeout(() => {
              setMessageData((prev) => {
                return [...response?.data?.items];
              });
            }, 300);
          } else {
            setMessageData((prev) => {
              return [...prev, ...response?.data?.items];
            });
          }
        } else {
          setIsLoading(false);
        }

        return response.data;
      } catch (error: any) {
        setIsLoading(false);

        console.log(error);

        if (error) {
          toast.error(error?.data ?? "채팅 조회에 실패했습니다.");
        }
      }
    },
    [page]
  );

  const targetRead = async () => {
    const queryStr = `${chatServerUrl}/message/read/${roomId ?? 0}`;

    try {
      const response = await axios.post(queryStr, {
        sid: encOwnerSuperKeyValueSid,
      });

      if (response?.status === 201) {
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }

      return response.data;
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (roomId > 0) {
      const socketIo = io(`${chatSocketUrl}`, {
        reconnection: false,
        transports: ["websocket"],
      });

      socketIo.connect();

      socketIo.on("connect", () => {
        console.log("😀 socket is connected");
        socketIo.emit("InAdmin");
      });

      socketIo.on("connect_error", (error) => {
        console.log("🥲 socket has connect_error: " + error);
      });

      socketIo.on("disconnect", (reason) => {
        console.log(`🥲 socket is disconnected: ${reason}`);
        // socket.connect();
        console.log(socketIo);
      });

      socketIo.on("reconnect", () => {
        console.log("😀 socket is reconnected!");
      });

      socketIo.on("receiveMessage", (data) => {
        console.log("✨ I got message in room: ", data);

        console.log(roomId, data?.roomId);

        if (roomId === data?.roomId) {
          console.log("same room");

          setMessageData((prev) => {
            const hasSameId =
              prev.filter((a) => a.id === data.id)?.length > 0 ? true : false;

            console.log("hasSameId", hasSameId);

            if (!hasSameId) {
              return [
                {
                  id: data.id,
                  roomid: data.roomId,
                  partyid: data.partyid,
                  writer: data.writer,
                  targetUid: data.targetUid,
                  isRead: data.isRead,
                  message: data.message,
                  date: data.date,
                },
                ...prev,
              ];
            } else {
              return [...prev];
            }
          });
        }
      });

      socketIo.on("read", (data) => {
        console.log("✏️ read: ", data);
        setMessageData((prev) => {
          const findIndex = prev.findIndex((element) => {
            return element?.id === data?.id; // 읽음으로 바꿔야 할 메시지
          });

          const copyArray = [...prev];
          copyArray[findIndex] = {
            ...copyArray[findIndex],
            isRead: 1, // 읽음 처리
          };

          if (findIndex >= 0) {
            targetRead();
          }

          return copyArray;
        });
      });

      return () => {
        socketIo.disconnect();
      };
    }
  }, [roomId]);

  // useEffect(() => {
  //   if (chatTab === 1) {
  //     console.log(socket);

  //     if (socket.connected) {
  //       socket.disconnect();
  //     }

  //     socket.connect();
  //   }

  //   return () => {
  //     socket.disconnect();
  //   };
  // }, [chatTab]);

  useEffect(() => {
    setHasMore(false);
    setMessageData([]);

    if (chatId) {
      getAllChat(true, chatId);
    }
  }, [chatId]);

  useEffect(() => {
    console.log("page", page);

    console.log("page is changed, so get all chat");
    if (page > 0) {
      getAllChat();
    }
  }, [page]);

  useEffect(() => {
    console.log("mount: ", mountCount);
    mountCount++;
    setDidMount(true);

    return () => {
      console.log("unmount");
    };
  }, []);

  useEffect(() => {
    console.log("didMount: ", didMount);
    if (didMount) {
      console.log("api 호출");
      setPage((prev) => prev + 1);
    }
  }, [didMount]);

  useEffect(() => {
    // 더 보여줄 page가 있고, 제일 상단 메세지가 보이면 page + 1
    if (lastInView && hasMore) {
      setPage((prev) => prev + 1);
    }
  }, [lastInView, hasMore]);

  useEffect(() => {
    console.log(messageData);
  }, [messageData]);

  return (
    <LineBox>
      <ChatContainer>
        <ChatHeader>
          {tableHead?.map((t) => (
            <SChatHeaderItem key={t}>{t}</SChatHeaderItem>
          ))}
        </ChatHeader>

        <ChatContent isMobile={isMobile}>
          {messageData?.map((m, index) => {
            const pureMsg = decryptChat(m?.message ?? "") ?? "";

            const isOldestChat = messageData.length === index + 1; // 가장 오래된 메세지
            const isLastChat = messageData[0]?.id === m?.id;

            return (
              <ChatRow
                key={index}
                ref={isOldestChat ? lastRef : undefined}
                grade={
                  +chatId?.split("@")[1]! === m?.writer
                    ? 0
                    : +chatId?.split("@")[2]! === m?.writer
                    ? 1
                    : undefined
                }
                isSystem={m?.writer === 0}
              >
                <SChatRowItem>{m?.id}</SChatRowItem>
                <SChatRowItem>
                  {m.writer === 0
                    ? "알림"
                    : +chatId?.split("@")[1]! === m?.writer
                    ? `파티장(${chatId?.split("@")[1] ?? 0})`
                    : +chatId?.split("@")[2]! === m?.writer
                    ? `파티원(${chatId?.split("@")[2 ?? 0]})`
                    : m?.writer}
                </SChatRowItem>
                <SChatRowItem>
                  <Flex>
                    <ChatMessage
                      dangerouslySetInnerHTML={{
                        __html: findUrl(pureMsg),
                      }}
                      onClick={() => {
                        const urlRegex =
                          /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;

                        const hasUrl = urlRegex?.test(pureMsg);

                        if (hasUrl) {
                          window.open(pureMsg);
                        }
                      }}
                    />

                    <>
                      {isLastChat && (
                        <LatestMessageBadge isSystem={true}>
                          가장 최근 메세지
                        </LatestMessageBadge>
                      )}
                    </>
                  </Flex>
                </SChatRowItem>
                <SChatRowItem>
                  {dayjs(m?.date)?.format("YYYY-MM-DD HH:mm:ss")}
                </SChatRowItem>
                <SChatRowItem>
                  {m?.writer === 0 ? (
                    <></>
                  ) : (
                    <Icon
                      src={require(`../../../../../../assets/${
                        m?.isRead ? "check_blue_24" : "check_black_24"
                      }@2x.png`)}
                    />
                  )}
                </SChatRowItem>
              </ChatRow>
            );
          })}
        </ChatContent>

        {isLoading && <Loader />}
      </ChatContainer>
    </LineBox>
  );
}

const SChatHeaderItem = styled(ChatHeaderItem)`
  &:nth-child(1) {
    flex: 1;
  }

  &:nth-child(2) {
    flex: 1;
  }

  &:nth-child(3) {
    flex: 4;
  }

  &:nth-child(4) {
    flex: 2;
  }

  &:nth-child(5) {
    flex: 1;
  }
`;

const SChatRowItem = styled(ChatRowItem)`
  &:nth-child(1) {
    flex: 1;
  }

  &:nth-child(2) {
    flex: 1;
  }

  &:nth-child(3) {
    flex: 4;
  }

  &:nth-child(4) {
    flex: 2;
  }

  &:nth-child(5) {
    flex: 1;
  }
`;

const Icon = styled.img`
  width: 24px;
  height: 24px;
`;
